import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { StandardAppLayout } from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import Loader from 'src/shared/components/loader/Loader';
import { Button } from 'src/shared/components/ui/button';
import { useCustomersQuery } from 'src/app/customers/state/api/customersGraphSlice';
import useCanAdministerOrganisations from 'src/app/admin/hooks/useCanAdministerOrganisations';
import OrganisationLozenge from 'src/app/admin/components/organisation-lozenge/OrganisationLozenge';
import GNPProjectsTable from './components/gnp-projects-table/GNPProjectsTable';
import AddProjectSheet from '../components/add-project-sheet/AddProjectSheet';

const GNPOrgManagement = () => {
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get('customerId');
    const { data, isLoading } = useCustomersQuery({});
    const canAdminister = useCanAdministerOrganisations();
    const [isAddProjectOpen, setIsAddProjectOpen] = useState(false);

    const organisation = data?.customers.find(customer => customer.customerId === customerId);

    if (isLoading) {
        return (
            <div className='flex justify-center py-24'>
                <Loader />
            </div>
        );
    }

    if (!organisation) {
        return (
            <StandardAppLayout
                title='Organisation'
                stickyHeader={false}
                mainContent={
                    <p className='text-sm text-grey-70' data-testid='org-page-not-found'>
                        That organisation could not be found.
                    </p>
                }
            />
        );
    }

    return (
        <StandardAppLayout
            title='Global Nature Performance Management'
            subTitle='Add projects to GNP and manage their definitions'
            stickyHeader={false}
            lozenges={<OrganisationLozenge customerId={organisation.customerId} customerName={organisation.customerName} />}
            mainContent={
                <div className='flex flex-col gap-8 pb-6'>
                    <section className='flex flex-col gap-3'>
                        <span className='text-xl text-black'>Projects</span>
                        <GNPProjectsTable
                            customerId={organisation.customerId}
                            actions={
                                canAdminister && (
                                    <Button onClick={() => setIsAddProjectOpen(true)} data-testid='org-page-add-project'>
                                        <Plus />
                                        Add project
                                    </Button>
                                )
                            }
                        />
                    </section>

                    <AddProjectSheet
                        open={isAddProjectOpen}
                        onOpenChange={setIsAddProjectOpen}
                        customerId={organisation.customerId}
                        customerName={organisation.customerName}
                    />
                </div>
            }
        />
    );
};

export default GNPOrgManagement;
